import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import Activity from "components/DigiHapi/Activity";
import FormSelect from "components/DigiHapi/FormSelect";
import ImageUpload from "components/CustomUpload/ImageUpload";

import { fetchGetTemplatesCategoriesIds } from "actions/template";
import {
	SET_TEMPLATE_CATEGORY,
	SET_TEMPLATE_NEW_CATEGORY,
	TOGGLE_ACCEPT_NOTIF,
	REMOVE_TEMPLATE_IMAGE,
	SET_TEMPLATE_FILES_IMAGES,
	SET_TEMPLATE_IMAGE_ERROR,
	SET_TEMPLATE_NAME_FR,
	SET_TEMPLATE_NAME_ERROR,
	SET_TEMPLATE_PICTO,
	TYPE_TEMPLATE,
	TYPE_ACTIVITY
} from "actions/types";

class Step1 extends Component {
	componentDidMount() {
		const { fetchGetTemplatesCategoriesIds, type, system, community } =
			this.props;
		fetchGetTemplatesCategoriesIds(type, system, community._id);
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, files, photoUri, name, type } = this.props;

		let success = true;
		if (files.length === 0 && !photoUri && type === "Template") {
			dispatch({
				type: SET_TEMPLATE_IMAGE_ERROR
			});
			success = false;
		}
		if (!name) {
			dispatch({
				type: SET_TEMPLATE_NAME_ERROR
			});
			success = false;
		}

		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_TEMPLATE_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_TEMPLATE_IMAGE
		});
	};

	render() {
		const {
			dispatch,
			_id,
			imageErrorMsg,
			categories,
			categoryId,
			newCategoryId,
			photoUri,
			acceptNotif,
			name,
			nameErrorMsg,
			categoryErrorMsg,
			picto,
			pictos,
			type,
			isFetching
		} = this.props;
		const category = _id ? newCategoryId : categoryId;
		return isFetching ? (
			<Activity />
		) : (
			<Grid container spacing={3} justifyContent="center">
				{type === "Template" && (
					<Grid item xs={12} sm={4}>
						<MDTypography component="div" variant="h6" mb={1}>
							Image *
						</MDTypography>
						<ImageUpload
							onImageLoaded={this.onImageLoaded}
							onImageRemoved={this.onImageRemoved}
							photoUri={photoUri}
						/>
						{imageErrorMsg && (
							<FormHelperText error>{imageErrorMsg}</FormHelperText>
						)}
					</Grid>
				)}
				{(type === "Activity" || type === "Proposal") && (
					<Grid item xs={12}>
						<FormSelect
							label="Sélectionner le pictogramme *"
							value={picto}
							placeholder="Pictogramme *"
							onChange={e =>
								dispatch({
									type: SET_TEMPLATE_PICTO,
									payload: e.target.value
								})
							}
						>
							{Object.entries(pictos || {}).map(([key, value]) => (
								<MenuItem key={key} value={key}>
									<MDBox
										component="img"
										src={value}
										alt={`${key} made by Freepik from www.flaticon.com`}
										width="2rem"
										height="2rem"
										sx={{ objectFit: "contain" }}
									/>
								</MenuItem>
							))}
						</FormSelect>
					</Grid>
				)}
				<Grid item xs={12}>
					<FormSelect
						label="Sélectionner la catégorie"
						value={category}
						placeholder="Catégorie *"
						error={!!categoryErrorMsg}
						helperText={categoryErrorMsg}
						options={(categories || []).map(({ _id, name }) => ({
							value: _id,
							label: name
						}))}
						onChange={e =>
							_id
								? dispatch({
										type: SET_TEMPLATE_NEW_CATEGORY,
										categoryId: e.target.value
								  })
								: dispatch({
										type: SET_TEMPLATE_CATEGORY,
										categoryId: e.target.value
								  })
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name-fr"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_NAME_FR,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Checkbox
								checked={!!acceptNotif}
								onChange={() =>
									dispatch({
										type: TOGGLE_ACCEPT_NOTIF
									})
								}
							/>
						}
						label="Accepter les alertes"
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		addTemplateResult,
		_id,
		categoryId,
		newCategoryId,
		name,
		description,
		photoUri,
		files,
		lang,
		dates,
		date,
		times,
		time,
		equipments,
		equipment,
		order,
		acceptNotif,
		imageErrorMsg,
		nameErrorMsg,
		categoryErrorMsg,
		picto
	} = state.templateReducer;

	const { pictos } = state.uploadReducer;

	const {
		isFetching,
		type,
		system,
		templatesCategoriesNames,
		activitiesCategoriesNames,
		proposalsCategoriesNames,
		systemTemplatesCategoriesNames,
		systemActivitiesCategoriesNames,
		systemProposalsCategoriesNames
	} = state.templateCategoryReducer;

	const { community } = state.entitiesReducer;

	return {
		isFetching,
		addTemplateResult,
		_id,
		categoryId,
		newCategoryId,
		name,
		description,
		photoUri,
		files,
		lang,
		categories:
			type === TYPE_TEMPLATE
				? system
					? systemTemplatesCategoriesNames
					: templatesCategoriesNames
				: type === TYPE_ACTIVITY
				? system
					? systemActivitiesCategoriesNames
					: activitiesCategoriesNames
				: system
				? systemProposalsCategoriesNames
				: proposalsCategoriesNames,
		dates,
		date,
		times,
		time,
		equipments,
		equipment,
		order,
		acceptNotif,
		imageErrorMsg,
		nameErrorMsg,
		categoryErrorMsg,
		picto,
		pictos,
		type,
		system,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetTemplatesCategoriesIds
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
